export enum SaveErrors {
  NO_ESTIMATE_NUMBER = 'No estimate number available',
  API_ERROR = 'API error occurred',
  IME_REJECTED = 'Estimate rejected by IME',
}

export enum ErrorCodes {
  BAD_ESTIMATION = 'BAD_ESTIMATION',
}
